window.initVariantSearchWeb = function() {
  const searchInput = document.getElementById('search-variant-input-web');
  if (!searchInput) {
    console.error("[initVariantSearchWeb] Search input not found, retrying...");
    setTimeout(window.initVariantSearchWeb, 100);
    return;
  }
  
  console.log("[initVariantSearchWeb] Variant search filter initialized.");

  // Remove any existing listener to prevent duplicates
  if (searchInput._variantSearchListener) {
    searchInput.removeEventListener('input', searchInput._variantSearchListener);
  }

  // Clean string by removing " and /
  const cleanString = str => str.replace(/["\/]/g, '');
  
  const variantSearchListener = function() {
    const searchTermRaw = searchInput.value.toLowerCase().trim();
    const cleanedSearchTerm = cleanString(searchTermRaw);
    const variantRows = document.querySelectorAll('.open-variant-drawer');
    variantRows.forEach(function(row) {
      const variantTitleRaw = (row.getAttribute('data-variant-title') || "").toLowerCase();
      const cleanedVariantTitle = cleanString(variantTitleRaw);
      
      // If search term has no spaces, split variant title and check tokens
      if (!searchTermRaw.includes(" ")) {
        const tokens = cleanedVariantTitle.split(/\s+/);
        row.style.display = tokens.includes(cleanedSearchTerm) ? "" : "none";
      } else {
        row.style.display = cleanedVariantTitle.includes(cleanedSearchTerm) ? "" : "none";
      }
    });
  };

  searchInput._variantSearchListener = variantSearchListener;
  searchInput.addEventListener('input', variantSearchListener);

  // Listen for a custom "paginationUpdated" event to re-run the search filter.
  document.addEventListener('paginationUpdated', function() {
    // Dispatch an input event to re-trigger the search filter.
    searchInput.dispatchEvent(new Event('input'));
  });
};

function observeSearchInput() {
  const container = document.querySelector('.search-wrapper') || document.body;
  const observer = new MutationObserver((mutations, obs) => {
    const newInput = document.getElementById('search-variant-input-web');
    if (newInput && !newInput._variantSearchListener) {
      window.initVariantSearchWeb();
    }
  });
  observer.observe(container, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', function() {
  window.initVariantSearchWeb();
  observeSearchInput();
});
